import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'twoDigitsConverter'
})
export class TwoDigitsConverterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return (value < 10) ? '0' + value.toString() : value.toString();
  }
}
